import { render, staticRenderFns } from "./DataTwins.vue?vue&type=template&id=39eef2a0&scoped=true"
import script from "./DataTwins.vue?vue&type=script&lang=js"
export * from "./DataTwins.vue?vue&type=script&lang=js"
import style0 from "./DataTwins.vue?vue&type=style&index=0&id=39eef2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eef2a0",
  null
  
)

export default component.exports